export default function wireCheckoutListeners(segment, ctx) {
    const { $uiEvents, store, $clientCookies } = ctx
    $uiEvents.$on('checkoutStarted', emitCheckoutStarted)
    $uiEvents.$on('orderPlaced', emitOrderPlaced)
    // THIPAY - Phone Payment Placed
    $uiEvents.$on('phonePaymentPlaced', emitPhonePaymentPlaced)

    // Gift Cards
    $uiEvents.$on('giftCardAdded', () => segment.track('Gift Card Added', {}))
    $uiEvents.$on('giftCardDenied', () => segment.track('Gift Card Denied', {}))
    $uiEvents.$on('giftCardRemoved', () => segment.track('Gift Card Removed', {}))

    // CHECKOUT STEPS - Realtruck Flow
    $uiEvents.$on('otherAddressFormViewed', () => emitCheckoutStepOneViewed('Other'))
    $uiEvents.$on('otherAddressFormCompleted', () => emitCheckoutStepOneCompleted('Other'))
    $uiEvents.$on('otherPaymentFormViewed', () => emitCheckoutStepTwoViewed('Other'))
    $uiEvents.$on('otherPaymentFormCompleted', () => emitCheckoutStepTwoCompleted('Other'))
    // CHECKOUT STEPS - Stripe
    $uiEvents.$on('stripePaymentInfoEntered', () => emitPaymentInfoEntered('Stripe', 2))
    // CHECKOUT STEPS - Affirm
    $uiEvents.$on('affirmAddressFormViewed', () => emitCheckoutStepOneViewed('Affirm'))
    $uiEvents.$on('affirmAddressFormCompleted', () => emitCheckoutStepOneCompleted('Affirm'))
    $uiEvents.$on('affirmPaymentModalViewed', () => emitCheckoutStepTwoViewed('Affirm'))
    $uiEvents.$on('affirmPaymentModalCompleted', () => emitCheckoutStepTwoCompleted('Affirm'))
    $uiEvents.$on('affirmPaymentInfoEntered', () => emitPaymentInfoEntered('Affirm', 2))
    // CHECKOUT STEPS - Paylpal
    $uiEvents.$on('paypalPaymentModalViewed', () => emitCheckoutStepOneViewed('Paypal'))
    $uiEvents.$on('paypalPaymentModalCompleted', () => emitCheckoutStepOneCompleted('Paypal'))
    $uiEvents.$on('paypalPaymentInfoEntered', () => emitPaymentInfoEntered('Paypal', 1))

    // STEPS
    // Paypal -> New Page -> Order Placed
    // Affirm -> Address -> Modal -> Order Placed
    const getStepsObj = (paymentMethod, step) => {
        return {
            checkout_id: store.state.checkout.data.checkout_id,
            step,
            payment_method: paymentMethod,
        }
    }

    function emitCheckoutStepOneViewed(paymentMethod) {
        segment.track('Checkout Step Viewed', getStepsObj(paymentMethod, 1))
    }

    function emitCheckoutStepOneCompleted(paymentMethod) {
        segment.track('Checkout Step Completed', getStepsObj(paymentMethod, 1))
    }

    function emitCheckoutStepTwoViewed(paymentMethod) {
        segment.track('Checkout Step Viewed', getStepsObj(paymentMethod, 2))
    }

    function emitCheckoutStepTwoCompleted(paymentMethod) {
        segment.track('Checkout Step Completed', getStepsObj(paymentMethod, 2))
    }

    function emitPaymentInfoEntered(paymentMethod, step) {
        segment.track('Payment Info Entered', getStepsObj(paymentMethod, step))
    }

    // THIPAY - Phone Payment Placed
    function emitPhonePaymentPlaced(data) {
        // We do not know their email currently but segment can match by Phone
        const identity = {
            phone: data.shippingAddress?.phone,
            address: data.shippingAddress,
        }
        segment.emitIdentify(identity)

        segment.track('Phone Order Completed', {
            sales_channel_name: data.salesChannelName,
            sales_rep_first_name: data.salesRepFirstName,
            order_number: data.orderNumber,
            total: data.orderTotal / 100,
            subtotal: data.orderSubtotal / 100,
            amount_paid: data.amountPaid / 100,
            amount_remaining: data.amountRemaining / 100,
            shipping: data.orderShippingCost / 100,
            tax: data.orderTax / 100,
            shippingAddress: data.shippingAddress,
            payment_complete: data.paymentComplete,
            currency: 'USD',
        })
    }

    function emitCheckoutStarted(paymentType) {
        const checkoutData = store.state.checkout.data
        const summary = checkoutData.summary

        segment.track('Payment Type Selected', {
            checkout_id: checkoutData.id,
            payment_method: paymentType,
        })

        segment.track('Checkout Started', {
            value: summary.grandTotal / 100, // Revenue ($) with discounts and coupons added in.
            revenue: summary.cartSubtotal / 100, // Revenue ($) associated with the transaction (excluding shipping and tax)
            shipping: summary.shippingSubtotal,
            tax: summary.taxSubtotal,
            // discount: 2.5,
            // coupon: 'hasbros',
            currency: 'USD',
            products: segment.getCartProducts(store.state.cart.data.items),
        })
    }

    async function emitOrderPlaced({ receiptObj, indexName, queryID }) {
        // segment.emitIdentify based on Shipping Address
        const shippingAddress = receiptObj.shippingContact
        const identity = {
            email: shippingAddress.email,
            name: shippingAddress.fullName,
            phone: shippingAddress.phone,
            address: shippingAddress,
        }

        // =========================
        // Unique to this flow, if we don't have a user id
        // we want to try to create one by secretly making the user
        // an account. We do not want to sign them in, just create the account
        // and snag the userId generated so we can Identify them.
        let userId = await segment.getUserId()
        if (!userId) userId = await segment.generateUserId(identity.email)

        // If we have a user id,  add it to the identity object
        if (userId) identity.userId = userId
        // =========================

        segment.emitIdentify(identity)

        const subscribeCookie =
            typeof $clientCookies.getJSON('checkoutSubscribe') === 'undefined'
                ? false
                : $clientCookies.getJSON('checkoutSubscribe')
        $clientCookies.remove('checkoutSubscribe')

        // subscribe them via segment event
        if (subscribeCookie) {
            if (subscribeCookie.subscribeEmail) {
                $uiEvents.$emit('newsletterSubscribed', {
                    formName: 'order-placed-subscribe',
                    email: shippingAddress.email,
                })
            }
            if (subscribeCookie.subscribeSms) {
                $uiEvents.$emit('newsletterSubscribedSms', {
                    formName: 'order-placed-subscribe',
                    email: shippingAddress.email,
                    phone: shippingAddress.phone,
                })
            }
        }

        trackOrderCompleted(receiptObj, indexName, queryID)
        trackAttribution(receiptObj)
    }

    async function trackOrderCompleted(receiptObj, indexName, queryID) {
        const {
            iterableTemplateId,
            iterableEmailCampaignId,
            iterableMessageId,
            iterableEndUserId,
        } = getIterableCookies()

        const products = []
        for (const index in receiptObj.items) {
            const item = receiptObj.items[index]
            // Format the base product data
            const product = segment.getCartProduct(item)
            product.objectID = await segment.getAlgoliaObjectId({
                productLineSlug: item.productLineSlug,
                skuSlug: item.productSlug,
                fitmentData: item.fitmentData,
            })

            products.push(product)
        }

        segment.track('Order Completed', {
            order_id: receiptObj.orderId,
            total: receiptObj.summary.grandTotal / 100, // Revenue ($) with discounts and coupons added in.
            subtotal: receiptObj.summary.cartSubtotal / 100, // Order total after discounts but before taxes and shipping
            revenue: receiptObj.summary.cartSubtotal / 100, // Revenue ($) associated with the transaction (excluding shipping and tax)
            shipping: receiptObj.summary.shippingSubtotal / 100,
            tax: receiptObj.summary.taxSubtotal / 100,
            // discount: 2.5,
            // coupon: 'hasbros',
            currency: 'USD',
            products,
            insideSale: receiptObj.insideSale,
            ...(indexName && { index: indexName }),
            ...(queryID && { queryID }),
            ...(iterableTemplateId && { iterableTemplateId }),
            ...(iterableEmailCampaignId && { iterableEmailCampaignId }),
            ...(iterableMessageId && { iterableMessageId }),
            ...(iterableEndUserId && { iterableEndUserId }),
        })
    }

    function trackAttribution(receiptObj) {
        const shippingAddress = receiptObj.shippingContact

        // Try to get new names
        let firstName = shippingAddress.firstName
        let lastName = shippingAddress.lastName

        // If they don't exist then try to get them the old way
        if (!firstName && shippingAddress.fullName)
            [firstName, lastName] = shippingAddress.fullName.split(' ')

        const fbp = $clientCookies.getJSON('_fbp')
        const fbc = $clientCookies.getJSON('_fbc')
        const {
            iterableTemplateId,
            iterableEmailCampaignId,
            iterableMessageId,
            iterableEndUserId,
        } = getIterableCookies()

        const geoPostalCode = segment.getGeoPostalCode()

        segment.track('Attribution Order Revenue', {
            currency: 'USD',
            email: shippingAddress.email,
            phone: shippingAddress.phone,
            firstName,
            lastName,
            address: shippingAddress.address1,
            city: shippingAddress.city,
            state: shippingAddress.stateId,
            zip: shippingAddress.zipcode,
            orderId: receiptObj.orderId,
            revenue: receiptObj.summary.cartSubtotal / 100,
            shipping: receiptObj.summary.shippingSubtotal / 100,
            subtotal: receiptObj.summary.cartSubtotal / 100,
            tax: receiptObj.summary.taxSubtotal / 100,
            total: receiptObj.summary.grandTotal / 100,
            products: segment.getCartProducts(receiptObj.items),
            insideSale: receiptObj.insideSale,
            ...(geoPostalCode && { geoPostalCode }),
            ...(fbp && { fbp }),
            ...(fbc && { fbc }),
            ...(iterableTemplateId && { iterableTemplateId }),
            ...(iterableEmailCampaignId && { iterableEmailCampaignId }),
            ...(iterableMessageId && { iterableMessageId }),
            ...(iterableEndUserId && { iterableEndUserId }),
        })
    }

    function getIterableCookies() {
        const iterableTemplateId = $clientCookies.getJSON('iterableTemplateId')
        const iterableEmailCampaignId = $clientCookies.getJSON('iterableEmailCampaignId')
        const iterableMessageId = $clientCookies.getJSON('iterableMessageId')
        const iterableEndUserId = $clientCookies.getJSON('iterableEndUserId')
        return {
            iterableTemplateId,
            iterableEmailCampaignId,
            iterableMessageId,
            iterableEndUserId,
        }
    }
}
